module.exports = __webpack_public_path__ + "img/s-cross.5d4882c8.svg";